var map = {
	"./en/i18nMain.js": 316,
	"./i18n.js": 48489,
	"./i18nData.js": 37273,
	"./vi/i18nAccount.js": 64116,
	"./vi/i18nAdmission.js": 91578,
	"./vi/i18nBaseForm.js": 9812,
	"./vi/i18nColumn.js": 80133,
	"./vi/i18nCommon.js": 51946,
	"./vi/i18nComponent.js": 96732,
	"./vi/i18nEnum.js": 80574,
	"./vi/i18nHome.js": 37932,
	"./vi/i18nMain.js": 77102,
	"./vi/i18nMessage.js": 18332,
	"./vi/i18nPages.js": 98815,
	"./vi/i18nProfile.js": 81454,
	"./vi/i18nReport.js": 90885,
	"./vi/i18nSchoolPortal.js": 58253,
	"./vi/i18nTable.js": 85387,
	"./vi/i18nValidate.js": 42729
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39057;